import { useContext } from "react";
import { HMIContext } from "contexts/HMIContext/HMIContext";
import { ViewOptionsEnum } from "components/ViewDropdown/ViewDropdown.view";
import { DowntimeCarousel } from "../../components/Carousels/DowntimeCarousel/DowntimeCarousel.view";
import { Details } from "../../components/Details/Details.view";

export const AvailabilityView = () => {
    const { view } = useContext(HMIContext);

    return view === ViewOptionsEnum.summary ? <DowntimeCarousel /> : <Details />;
};
